import PartiuGpInglaterra from '@/components/templates/PartiuGpInglaterra';

export default function PartiuGpInglaterraPage() {
  return <PartiuGpInglaterra />;
}
